import inobounce from 'inobounce';
import createFocusTrap from 'focus-trap';
import Toggle from '../lib/Toggle';
import MediaQuery from '../lib/MediaQuery';
import scrollingElement from '../utils/scrollingElement';
import { getFocusableElements } from '../utils/getFocusableElements';
import { isNull } from '../utils/type';

export default function v1HeaderToggle() {
  const toggleButtonElm = document.getElementById('v1-headerToggle__button');
  const toggleCloseSpElm = document.getElementById('v1-headerCloseSp');
  const searchToggleButtonElm = document.getElementById('v1-headerSearch__toggleButton');
  const searchCloseButtonElm = document.getElementById('v1-headerSearch__closeButton');
  const navElm = document.getElementById('v1-header__nav');
  const subNavDestinationsElm = document.getElementById('subNavDestinations');
  const subNavSearchElm = document.getElementById('v1-headerSearch__area');
  const subNavTailoredElm = document.getElementById('subNavTailored');
  const mainNavDestinationsElm = document.getElementById('mainNavDestinations');
  const mainNavTailoredElm = document.getElementById('mainNavTailored');
  const destinationsCloseButtonElm = document.getElementById('v1-headerDestinations__closeButton');
  const destinationsCloseButtonSpElm = document.getElementById(
    'v1-headerDestinations__closeButtonSp',
  );
  const destinationsCloseButtonSpElm2 = document.getElementById(
    'v1-headerDestinations__closeButtonSp2',
  );
  const tailoredCloseButtonElm = document.getElementById('v1-headerTailored__closeButton');
  const tailoredCloseButtonSpElm = document.getElementById('v1-headerTailored__closeButtonSp');
  const tailoredCloseButtonSpElm2 = document.getElementById('v1-headerTailored__closeButtonSp2');
  const headerHeadElm = document.getElementById('v1-header__head');
  const headerBodyElm = document.getElementById('v1-header__body');
  const headerInfoElm = document.getElementById('v1-header__info');
  const headerInputElm = document.getElementsByClassName('v1-headerSearchSp__input')[0];

  const htmlElm = document.getElementsByTagName('html')[0];
  const bodyElm = document.getElementsByTagName('body')[0];

  const isIOS = /iP(hone|(o|a)d)/.test(navigator.userAgent);

  const fixedClass = '-fixed';
  const scrollElement = scrollingElement();
  // メニューを開く直前のスクロール位置。
  let openBeforeLocation = 0;
  // ナビがfixedされているかのフラグ
  let fixedNavSp = false;

  // サイト内検索の有無でエラーが起きないように制御するためのフラグ
  const hasSearchElement = !!subNavSearchElm;
  const hasTailoredElement = !!mainNavTailoredElm;

  inobounce.disable();

  if (!headerHeadElm) return;

  function fixedOn() {
    htmlElm.classList.add('-fixed');
    bodyElm.classList.add('-fixed');
  }

  function fixedOff() {
    htmlElm.classList.remove('-fixed');
    bodyElm.classList.remove('-fixed');
  }

  // ハンバーガーメニュー内の要素を取得する
  const focusableNavElements = getFocusableElements(navElm);

  const focusableNavElementsTabindexArray = Array.from(focusableNavElements).map(element => {
    return element.getAttribute('tabindex');
  });

  // ハンバーガーメニュー内の要素に`tabindex="-1"`を指定する
  const disableFocusNavElements = () => {
    Array.from(focusableNavElements).forEach(element => {
      element.setAttribute('tabindex', '-1');
    });
  };

  // ハンバーガーメニュー内の要素の`tabindex`をリセットする
  const recoverFocusNavElements = () => {
    Array.from(focusableNavElements).forEach((element, index) => {
      const tabindex = focusableNavElementsTabindexArray[index];

      if (isNull(tabindex)) {
        element.removeAttribute('tabindex');
        return;
      }

      element.setAttribute('tabindex', `${tabindex}`);
    });
  };

  MediaQuery.matches('lg', matches => {
    if (matches) {
      recoverFocusNavElements();
    }

    if (!matches) {
      disableFocusNavElements();
    }
  });

  /**
   * フォーカストラップをしないために、メニューの外にフォーカスが当たらないようにする。
   */
  const focusTrapToggle = createFocusTrap('#v1-header__nav', {
    clickOutsideDeactivates: true,
    initialFocus: '#v1-header__nav',
  });
  const focusTrapTailored = createFocusTrap('#subNavTailored', {
    clickOutsideDeactivates: true,
    initialFocus: '#subNavTailored',
  });
  const focusTrapDestinations = createFocusTrap('#subNavDestinations', {
    clickOutsideDeactivates: true,
    initialFocus: '#subNavDestinations',
  });
  const focusTrapSearch = createFocusTrap('#v1-headerSearch__area', {
    clickOutsideDeactivates: true,
    initialFocus: '#v1-headerSearch__area',
  });

  /**
   * ハンバーガーメニュー。
   */
  const menu = new Toggle({
    triggerID: 'v1-headerToggle__button',
    contentID: 'v1-header__nav',
    showFocusElement: '#v1-header__nav',
    hideFocusElement: '#v1-headerToggle__button',
    beforeShow() {
      openBeforeLocation = window.pageYOffset;
      fixedNavSp = !!headerBodyElm.className.includes(fixedClass);

      navElm.setAttribute('tabindex', '-1');
      recoverFocusNavElements();

      if (hasSearchElement) {
        search.hide(); // eslint-disable-line
      }

      focusTrapToggle.activate();

      if (isIOS) {
        inobounce.enable();
      }
      fixedOn();

      if (fixedNavSp) {
        // fixed状態でナビを開く場合は、ロゴエリアを一時的に見えなくする
        headerHeadElm.style.height = '0';
        if (headerInfoElm) {
          headerInfoElm.style.display = 'none';
        }
      }
      if (!fixedNavSp) {
        // fixedしていない状態でナビを開く場合は、スクロール位置をページ上部にする
        window.scrollTo(0, 0);
      }
    },
    afterShow() {
      const headerHeadHeight = headerHeadElm.clientHeight;
      const headerBodyHeight = headerBodyElm.clientHeight;
      const documentHeight = window.innerHeight;
      // Android Chromeでアドレスバーが隠れて余分なスペースができてしまうためのマジックナンバー
      const offsetHeight = 60;

      if (fixedNavSp) {
        // fixed状態の場合は`#v1-header__body`分のオフセットをとる
        navElm.style.top = `${headerBodyHeight - 2}px`;
        // navElm.style.top = headerInfoElm
        //           ? `${headerInfoElm.clientHeight + headerBodyHeight - 2}px`
        //           : `${headerBodyHeight - 2}px`;
      }

      if (!fixedNavSp) {
        // fixed状態でない場合は`#v1-header__head`分のオフセットも追加する
        navElm.style.top = headerInfoElm
          ? `${headerInfoElm.clientHeight + headerHeadHeight + headerBodyHeight - 1}px`
          : `${headerHeadHeight + headerBodyHeight - 1}px`;
      }
      const navHeight = fixedNavSp
        ? documentHeight - headerBodyHeight
        : documentHeight - headerHeadHeight - headerBodyHeight + offsetHeight;
      setTimeout(function() {// eslint-disable-line
        // 開閉時のアニメーション
        navElm.style.height = `${navHeight}px`;
      }, 0);

      if (fixedNavSp) {
      setTimeout(function() {// eslint-disable-line
          headerBodyElm.classList.add(fixedClass);
        }, 0);
      }
    },
    beforeHide() {
      if (isIOS) {
        inobounce.disable();
      }

      focusTrapToggle.deactivate();

      MediaQuery.matches('lg', matches => {
        if (!matches) {
          disableFocusNavElements();
        }
      });

      fixedOff();

      if (fixedNavSp) {
        headerHeadElm.style.height = '';
        if (headerInfoElm) {
          headerInfoElm.style.display = '';
        }
      }

      if (!fixedNavSp) {
        const headerHeadHeight = headerHeadElm.clientHeight;
        const headerBodyHeight = headerBodyElm.clientHeight;

        // ナビを閉じる時の上位置を`#v1-header__body`と合わせる
        navElm.style.top = `${headerHeadHeight + headerBodyHeight - openBeforeLocation}px`;
      }
      const isOpen =
        document.getElementById(this.triggerID).getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        // ナビを開いた位置にスクロール位置を戻す
        scrollElement.scrollTop = openBeforeLocation;
      }
    },
    afterHide() {
      navElm.style.height = '';
      setTimeout(() => {
        toggleButtonElm.focus();
      }, 0);
    },
  });

  /**
   * 検索フォーム。
   */
  const search = new Toggle({ // eslint-disable-line
    triggerID: 'v1-headerSearch__toggleButton',
    contentID: 'v1-headerSearch__area',
    showFocusElement: '#search2',
    hideFocusElement: '#v1-headerSearch__toggleButton',
    beforeShow() {
      subNavSearchElm.setAttribute('tabindex', '-1');
      menu.hide(); // eslint-disable-line
      destinations.hide(); // eslint-disable-line
      if (hasSearchElement) {
        search.hide(); // eslint-disable-line
        focusTrapSearch.activate();
      }
      if (hasTailoredElement) {
        tailored.hide(); // eslint-disable-line
      }
    },
    beforeHide() {
      if (hasTailoredElement) {
        focusTrapSearch.deactivate();
      }
    },
  });

  /**
   * destinationsのトグル処理
   */
  const destinations = new Toggle({
    triggerID: 'mainNavDestinations',
    contentID: 'subNavDestinations',
    hideFocusElement: '#mainNavDestinations',
    beforeShow() {
      subNavDestinationsElm.setAttribute('tabindex', '-1');
      if (hasSearchElement) {
        search.hide(); // eslint-disable-line
      }
      if (hasTailoredElement) {
        tailored.hide(); // eslint-disable-line
      }
      focusTrapDestinations.activate();
    },
    afterShow() {
      MediaQuery.matches('lg', matches => {
        if (matches) {
          window.scrollTo(0, 0);
        }
      });
    },
    beforeHide() {
      focusTrapDestinations.deactivate();
    },
  });

  /**
   * Tailored Tripsのトグル処理
   */
  const tailored = new Toggle({
    triggerID: 'mainNavTailored',
    contentID: 'subNavTailored',
    hideFocusElement: '#mainNavTailored',
    beforeShow() {
      subNavTailoredElm.setAttribute('tabindex', '-1');
      if (hasSearchElement) {
        search.hide(); // eslint-disable-line
      }
      destinations.hide(); // eslint-disable-line
      focusTrapTailored.activate();
    },
    afterShow() {
      MediaQuery.matches('lg', matches => {
        if (matches) {
          window.scrollTo(0, 0);
        }
      });
    },
    beforeHide() {
      focusTrapTailored.deactivate();
    },
  });

  /**
   * 各ドロップダウンを初期化。
   */
  menu.init();
  if (hasSearchElement) {
    search.init(); // eslint-disable-line
  }
  destinations.init();
  if (hasTailoredElement) {
    tailored.init();
  }

  /**
   * iOSでドキュメントの位置がずれるのを調整する
   */
  if (headerInputElm) {
    headerInputElm.addEventListener('blur', () => {
      setTimeout(() => {
        scrollElement.scrollTop = 0;
      }, 1000 / 60);
    });
  }

  /**
   * 各closeボタンの処理
   */
  toggleCloseSpElm.addEventListener('click', e => {
    menu.hide();
    e.preventDefault();
  });

  if (hasSearchElement) {
    searchCloseButtonElm.addEventListener('click', e => {
      if (hasSearchElement) {
        search.hide(); // eslint-disable-line
      }
      searchToggleButtonElm.focus();
      e.preventDefault();
    });
  }

  destinationsCloseButtonElm.addEventListener('click', e => {
    destinations.hide();
    subNavDestinationsElm.setAttribute('tabindex', '-1');
    mainNavDestinationsElm.focus();
    e.preventDefault();
  });
  destinationsCloseButtonSpElm.addEventListener('click', e => {
    destinations.hide();
    subNavDestinationsElm.setAttribute('tabindex', '-1');
    mainNavDestinationsElm.focus();
    e.preventDefault();
  });
  destinationsCloseButtonSpElm2.addEventListener('click', e => {
    destinations.hide();
    subNavDestinationsElm.setAttribute('tabindex', '-1');
    mainNavDestinationsElm.focus();
    e.preventDefault();
  });

  if (hasTailoredElement) {
    tailoredCloseButtonElm.addEventListener('click', e => {
      tailored.hide();
      subNavTailoredElm.setAttribute('tabindex', '-1');
      mainNavTailoredElm.focus();
      e.preventDefault();
    });
    tailoredCloseButtonSpElm.addEventListener('click', e => {
      tailored.hide();
      subNavTailoredElm.setAttribute('tabindex', '-1');
      mainNavTailoredElm.focus();
      e.preventDefault();
    });
    tailoredCloseButtonSpElm2.addEventListener('click', e => {
      tailored.hide();
      subNavTailoredElm.setAttribute('tabindex', '-1');
      mainNavTailoredElm.focus();
      e.preventDefault();
    });
  }

  /**
   * ドキュメントをクリックすると、ドロップダウンを閉じる。
   * そのドロップダウンの要素内の場合は処理しない。
   */
  document.addEventListener('click', e => {
    const { target } = e;
    const hasUserNav = !!target.closest('.v1-header__nav');
    const hasAutocomplete = !!target.closest('.ui-autocomplete');
    const hasSearch = !!target.closest('.v1-headerSearch');
    const hasDestinations = !!target.closest('#subNavDestinations');
    const hasTailored = !!target.closest('#subNavTailored');
    const flightModal = !!target.closest('#modu001');
    const hasContents = !!target.closest(
      'main, [id="v1-header"] ~ *:not([class="v1-footer"]):not([id="footer"]), [class="v1-footer"]',
    );

    if (!hasUserNav && !hasAutocomplete && !flightModal && !hasContents) {
      MediaQuery.matches('lg', matches => {
        if (!matches) {
          menu.hide();
        }
      });
    }

    if (!hasSearch && hasSearchElement && !hasAutocomplete && !flightModal) {
      search.hide(); // eslint-disable-line
    }

    if (!hasDestinations && !hasAutocomplete && !flightModal) {
      destinations.hide();
    }

    if (!hasTailored && hasTailoredElement && !hasAutocomplete && !flightModal) {
      tailored.hide();
    }
  });

  const allHide = () => {
    // メニューが開いていたら閉じる
    const isMenuOpen =
      document.getElementById('v1-headerToggle__button').getAttribute('aria-expanded') === 'true';
    if (isMenuOpen) {
      menu.hide();
    }
    if (hasSearchElement) {
      search.hide();
    }
    destinations.hide();
    if (hasTailoredElement) {
      tailored.hide();
    }
  };

  /**
   * Escapeキーを押すとすべてのメニューを閉じる。
   */
  document.addEventListener('keyup', e => {
    if (e.key === 'Escape' || e.key === 'Esc') {
      allHide();
    }
  });
}
